import type { MeasureMetadata } from '../../../api/work-periods-client/work-periods-client.type';
import { primaryBase, redBase } from '../../../styles/design-tokens';
import { Icon } from '../../../ui-library/icon/icon';
import { Text } from '../../../ui-library/typography/typography';
import { TruncatedText } from '../../adherence/risk-analysis/truncated-text';
import { Table, TableColumn } from '../../data-management/components/table';
import { getMeasureMetadataId } from '../calculations.helpers';

interface CalculationsTableProps {
  measures: MeasureMetadata[];
  showSprintColumn?: boolean;
  sprintMeasures?: MeasureMetadata[];
}

export const CalculationsTable = ({
  measures,
  showSprintColumn = false,
  sprintMeasures = [],
}: CalculationsTableProps) => {
  const columns: TableColumn<MeasureMetadata>[] = [
    {
      key: 'measure_title',
      label: 'Name',
      width: '15%',
      render: (value) => (
        <Text weight="medium" size="small">
          {value as string}
        </Text>
      ),
    },
    {
      key: 'measure_description',
      label: 'Description',
      width: '30%',
      render: (value) => <TruncatedText text={value ? (value as string) : '-'} maxLength={80} textSize="small" />,
    },
    {
      key: 'measure_purpose',
      label: 'Purpose',
      width: '30%',
      render: (value) => <TruncatedText text={value ? (value as string) : '-'} maxLength={80} textSize="small" />,
    },
    {
      key: 'measure_units',
      label: 'Units',
      width: showSprintColumn ? '10%' : '10%',
      render: (value) => <Text size="small">{value ? (value as string) : '-'}</Text>,
    },
  ];

  // Add sprint column only if showSprintColumn is true
  if (showSprintColumn) {
    columns.push({
      key: 'measure_name',
      label: 'Sprint Measure',
      width: '15%',
      render: (_, row) => {
        const isSprintMeasure = sprintMeasures.some(
          (sprintMeasure) => getMeasureMetadataId(sprintMeasure) === getMeasureMetadataId(row),
        );
        return isSprintMeasure ? (
          <Icon name="check" size={20} color={primaryBase} />
        ) : (
          <Icon name="close" size={20} color={redBase} />
        );
      },
    });
  }

  return (
    <Table<MeasureMetadata>
      data={measures}
      columns={columns}
      getRowId={(measure) => getMeasureMetadataId(measure)}
      stickyHeader
    />
  );
};
